var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { benefit, getBeneficiary, getBeneficiaryClearData, patchBeneficiary, } from "../../../store/beneficiary/actions";
import { insured } from "../../../store/insured/actions";
import { newFormattedDate, newFormattedDateYYMMDD } from "../../../utils/date";
import { removeNonNumeric } from "../../../services/functions";
import { formatPhoneNumber } from "../../../utils/formats";
var useBeneficiary = function (setIsUpdate, setInitialPercentage, setTitleBeneficiary, setOpenModalBeneficiary, dataFormBeneficiary, setDataFormBeneficiary, initialPercentage, responseOneQuote, clientId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType) {
    var _a;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    // Memoize the translation function for performance, although typically not necessary unless `t` depends on props or state
    var tMemo = useMemo(function () { return t; }, [t]);
    // Use useCallback for functions that might be passed down as props to child components
    var setBeneficiaryStorybook = useCallback(function (responseBeneficiary) {
        var beneficiaryRows = responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.map(function (b) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return ({
                id: b.id,
                type: (_b = (_a = b.catalogBeneficiaryTypeInfo) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : "",
                percentage: "".concat(b.percentage, " %"),
                names: "".concat((_c = b.personInfo) === null || _c === void 0 ? void 0 : _c.firstNameA, " ").concat((_d = b.personInfo) === null || _d === void 0 ? void 0 : _d.firstNameB),
                lastNames: "".concat((_e = b.personInfo) === null || _e === void 0 ? void 0 : _e.lastNameA, " ").concat((_f = b.personInfo) === null || _f === void 0 ? void 0 : _f.lastNameB),
                marriedName: (_h = (_g = b.personInfo) === null || _g === void 0 ? void 0 : _g.marriedName) !== null && _h !== void 0 ? _h : "",
                phone1: (_k = formatPhoneNumber(((_j = b.personInfo) === null || _j === void 0 ? void 0 : _j.phone1) || "")) !== null && _k !== void 0 ? _k : "",
                dob: (_m = newFormattedDate((_l = b.personInfo) === null || _l === void 0 ? void 0 : _l.dob)) !== null && _m !== void 0 ? _m : "",
                documentNumber: (_p = (_o = b.personInfo) === null || _o === void 0 ? void 0 : _o.numberId) !== null && _p !== void 0 ? _p : "",
                idType: (_r = (_q = b.personInfo) === null || _q === void 0 ? void 0 : _q.identificationTypeId) !== null && _r !== void 0 ? _r : "",
                idTypeInsured: (_t = (_s = b.catalogBeneficiaryTypeInfo) === null || _s === void 0 ? void 0 : _s.id) !== null && _t !== void 0 ? _t : "",
            });
        });
        dispatch(getBeneficiaryClearData());
        return beneficiaryRows;
    }, [dispatch]);
    var handleAddBeneficiary = function () {
        setIsUpdate(false);
        setInitialPercentage(45);
        setTitleBeneficiary(t("confirmationData.titleBeneficiary"));
        setOpenModalBeneficiary(true);
        setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { Id: "", DocumentNumber: "", Name: "", LastNameA: "", LastNameB: "", marriedName: "", Birthday: "", PhoneNumber: "", IdTypeName: "" }));
    };
    var handleSubmitBeneficiary = useCallback(function (data) {
        var _a, _b;
        var openModalBeneficiary = false;
        var body = {
            percentage: data.Percentage
                ? data.Percentage.toString()
                : initialPercentage.toString(),
            quoteId: (_a = responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.id,
            catalogBeneficiaryType: data.idTypeInsured,
            person: {
                identificationTypeId: data.IdType,
                firstNameA: data.Name,
                firstNameB: data.SecondName,
                numberId: (_b = data.DocumentNumber) === null || _b === void 0 ? void 0 : _b.replace(/-/g, ""),
                lastNameA: data.LastNameA,
                lastNameB: data.LastNameB,
                marriedName: data.marriedName,
                phone1: removeNonNumeric(data.PhoneNumber),
                dob: data.Birthday,
                clientId: clientId,
            },
        };
        if (isUpdate) {
            dispatch(patchBeneficiary({ body: body, id: data.Id }));
            getInsuredBeneficiary();
            openModalBeneficiary = false;
            setOpenModalBeneficiary(false);
        }
        else {
            dispatch(benefit(body));
        }
        return openModalBeneficiary;
    }, [
        clientId,
        dispatch,
        initialPercentage,
        isUpdate,
        (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.id,
        setOpenModalBeneficiary,
    ]);
    var getInsuredBeneficiary = useCallback(function () {
        var _a;
        if (responseOneQuote && responseOneQuote.data) {
            var _id = (_a = responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.id;
            if (_id !== undefined) {
                dispatch(getBeneficiary({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: _id,
                }));
                dispatch(insured({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: _id,
                }));
            }
        }
    }, [dispatch, responseOneQuote]);
    var editBeneficiary = function (row) {
        setIsMaskedDocument(false);
        setIsUpdate(true);
        setPersonId(row.row.id);
        setTitleBeneficiary(tMemo("confirmation.editBeneficiary"));
        setOpenModalBeneficiary(true);
        setInitialPercentage(parseFloat(row.row.percentage.replace("%", "")));
        var names = row.row.names.split(" ");
        var firstNameA = names[0] || "";
        var firstNameB = names[1] || "";
        var lastNames = row.row.lastNames.split(" ");
        var lastNameA = lastNames[0] || "";
        var lastNameB = lastNames[1] || "";
        listIdentificationType.forEach(function (item) {
            if (item.name === "Pasaporte" && item.id === row.row.idType) {
                setIsMaskedDocument(true);
            }
        });
        setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { Id: row.row.id, IdType: row.row.idType, DocumentNumber: row.row.documentNumber, Name: firstNameA, SecondName: firstNameB, LastNameA: lastNameA, LastNameB: lastNameB, marriedName: row.row.marriedName, Birthday: newFormattedDateYYMMDD(row.row.dob), PhoneNumber: row.row.phone1, idTypeInsured: row.row.idTypeInsured, Percentage: initialPercentage }));
    };
    return useMemo(function () { return ({
        setBeneficiaryStorybook: setBeneficiaryStorybook,
        handleAddBeneficiary: handleAddBeneficiary,
        handleSubmitBeneficiary: handleSubmitBeneficiary,
        getInsuredBeneficiary: getInsuredBeneficiary,
        editBeneficiary: editBeneficiary,
    }); }, [
        setBeneficiaryStorybook,
        handleAddBeneficiary,
        handleSubmitBeneficiary,
        getInsuredBeneficiary,
        editBeneficiary,
    ]);
};
export default useBeneficiary;
